import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import isEmpty from 'lodash/isEmpty';

import RoomList from '../RoomList/index';
import PmList from 'pm-js/build/components/PmList/index';
import XXLFunctionsBanner from '../XXLFunctionsBanner/index';

import BecomeXXLPopup from '../BecomeXXLPopup/index';
import RoomCreatePopup from '../RoomCreatePopup/index';
import SettingsPopup from '../SettingsPopup/index';
import UserSettings from '../SettingsPopup/UserSettings';
import RoomSettings from '../SettingsPopup/RoomSettings';
import ShowroomSettings from '../ShowroomSettings/index';

import Registry from '../../../registry/index';

import { ROOM_TYPE_PERSONAL } from '../../../constants/rooms';

import { closeNotificationsWindow, getMemberNotificationsList } from '../../../actions/notifications';
import { minimizeAllPmWindows, maximizePmWindow } from '../../../actions/pm';
import { hideLeftSidebar } from '../../../actions/sidebars';

import NotificationsWindow from '../NotificationsWindow';
import FullscreenButton from "../FullscreenButton";
import Notification from '../Notification';
import SidebarMenu from '../SidebarMenu';

function HeaderGeneral() {
    let chatInterface = Registry.get('chatInterface');

    return (
        <div className="header-general">
            <a href="/" target="_blank"><span>BobTV <u>|</u> <b>{chatInterface.getChatRoomName()}</b></span></a>
        </div>
    )
}

function RoomEditor({currentRoom, currentUser, lang}) {
    let openRoomEditor = function() {
        SettingsPopup.open({
            title: lang.edit_my_room,
            content: <RoomSettings currentUser={currentUser}
                                  currentRoom={currentRoom}
                                onCancel={() => SettingsPopup.close()}
                                onSuccess={() => SettingsPopup.close()}/>
        });
    }
    
    if (currentUser.uid != currentRoom.creator.uid) return null;
    if (currentRoom.type != ROOM_TYPE_PERSONAL) return null;
    return (<ShowroomSettings currentUser={currentUser} currentRoom={currentRoom}/>);
    return (<span className="openRoomEditor">
              <a onClick={openRoomEditor} className="openRoomEditor settings"></a>
            </span>);
}

function HeaderPersonal({currentRoom, currentUser, lang, onRoomChangedMobile}) {
    let showroom = currentRoom.showroom_price ? true : false;
    if (showroom) return HeaderShowroom({currentRoom, currentUser, lang, onRoomChangedMobile});
    return (
        <div className="header-personal">
            <span><b>My</b> <u>|</u> BobTV</span> 
            <div className="subtitle" title={currentRoom.name} onClick={() => onRoomChangedMobile()}>{currentRoom.name}</div>
            <div className="creator">{lang.creator_} <a href={currentRoom.creator.getProfileURL()} target="_blank">{currentRoom.creator.nick}</a></div>
            
            <RoomEditor currentRoom={currentRoom} currentUser={currentUser} lang={lang} />
        </div>
    )
}

function HeaderShowroom({currentRoom, currentUser, lang, onRoomChangedMobile}) {

    return (
        <div className="header-personal">
            <span><b>My</b> <u>|</u> Show</span> 
            <div className="subtitle" title={currentRoom.name} onClick={() => onRoomChangedMobile()}>{currentRoom.name}</div>
            <div className="creator">{lang.creator_} <a href={currentRoom.creator.getProfileURL()} target="_blank">{currentRoom.creator.nick}</a></div>
            
            <RoomEditor currentRoom={currentRoom} currentUser={currentUser} lang={lang} />
            
        </div>
    )
}

class SidebarLeft extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cssClass: props.sidebarLeftShown ? 'shown' : 'hidden'
        };

        this.onAnimationEnd = this.onAnimationEnd.bind(this);
        this.onRoomChangedMobile = this.onRoomChangedMobile.bind(this);
    }

    onAnimationEnd(event) {
        switch (event.animationName) {
            case 'left_cont_show':
                this.setState({cssClass: 'shown'});
                // this.props.onShowFn();
                break;
            case 'left_cont_hide':
                this.setState({cssClass: 'hidden'});
                // this.props.onHideFn();
                break;
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.sidebarLeftShown !== nextProps.sidebarLeftShown) {
            if (nextProps.sidebarLeftShown) {
                this.setState({cssClass: 'showing_up'})
            } else {
                this.setState({cssClass: 'hiding_up'})
            }
        }
    }

    actionFn() {
        let {dispatch} = this.props;
        //dispatch({type: })
    }

    onCreateRoomClick = event => {
        event.preventDefault();

        let {currentUser}  = this.props;

        if (!currentUser.isAnonymous() && !currentUser.isXXL()) {
            BecomeXXLPopup.open("create-room");
            return false;
        }

        RoomCreatePopup.open({currentUser});
    };

    onRoomChangedMobile() {
        let {minimizeAllPmWindows, hideLeftSidebar, closeNotificationsWindow} = this.props;

        hideLeftSidebar();
        closeNotificationsWindow();
        minimizeAllPmWindows();
    }

    onPmListItemClick(conversation) {
        //this.props.dispatch({type: "PM_WINDOW_MAXIMIZE", conversation: conversation, user:conversation.user})
        this.props.maximizePmWindow(conversation.user);

    }

    renderNotificationsWindow(props, state) {
        NotificationsWindow.mount({
            ...props,
            parentState: state,
            minimizeFn: this.minimize,
            hideFn: this.hide,
            ref: (r) => this.window = r
        });
    }

    componentDidMount() {
        const siteInterface = Registry.get('siteInterface');
        siteInterface.getMemberNotificationList()
            .then(data => this.props.getMemberNotificationsList(data.data.data))
            .catch(e => console.log(e));
        this.renderNotificationsWindow(this.props, this.state);
    }

    componentWillUpdate(nextProps, nextState) {
        const htmlClasses = document.documentElement.classList;

        const { notifications } = nextProps;
        if (notifications.showNotificationsWindow) {
            htmlClasses.add('notifications-active');
        } else {
            htmlClasses.remove('notifications-active');
        }

        this.renderNotificationsWindow(nextProps, nextState);
    }
    
    componentWillUnmount() {
        try {
            NotificationsWindow.unmount(this.props);
        } catch (e) {
            console.log("NotificationsWindow.unmount is not a function.");
        }

    }

    render() {
        let lang = Registry.get('locale');

        let cssClasses = ['left-cont'];
        cssClasses.push(this.state.cssClass);

        const { currentRoom, currentUser, browser, notifications } = this.props;
        let isPersonal = (currentRoom.type === ROOM_TYPE_PERSONAL);
        const filteredList = notifications.list.filter(item => (item.data.visibility === 'personal' && item.data.is_read === 0));

        return (
            <div className={cssClasses.join(' ')} onAnimationEnd={this.onAnimationEnd}>
                <div className="block-left-cont">
                    <div className="block-top-left-cont">
                        {currentRoom.exists && currentRoom.type === ROOM_TYPE_PERSONAL ?
                            <HeaderPersonal currentRoom={currentRoom} currentUser={currentUser} lang={lang} onRoomChangedMobile={this.onRoomChangedMobile}/> :
                            <HeaderGeneral lang={lang}/>
                        }
                    </div>
                    <div className="block-list height" id="#block-list">
                        <div id="room-list-container">
                            
                            {!isEmpty(filteredList) && <Notification notification={filteredList[0]} counter={filteredList.length} />}

                            {!isPersonal && <p className="name group">
                                {lang.rooms}
                                <a className="create-room-icon" onClick={this.onCreateRoomClick} title={lang.create_new_room}/>
                            </p>}
                            <Scrollbars
                                renderTrackVertical={props => <div {...props} className="track-vertical"/>}
                                renderThumbVertical={props => <div {...props} className="thumb-vertical"/>}
                            >
                                <RoomList onRoomChangedMobile={this.onRoomChangedMobile}/>
                                <PmList onClick={this.onPmListItemClick.bind(this)}/>
                            </Scrollbars>
                        </div>
                    </div>
                    <SidebarMenu />
                    <FullscreenButton shown={this.props.sidebarLeftShown}/>
                    <XXLFunctionsBanner browser={browser} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        sidebarLeftShown: state.sidebars.leftShown,
        notifications: state.notifications,
        currentRoom: state.currentRoom,
        currentUser: state.currentUser,
        browser: state.browser
    }
}

let mapDispatchToProps = {
    getMemberNotificationsList,
    closeNotificationsWindow,
    minimizeAllPmWindows,
    maximizePmWindow,
    hideLeftSidebar
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarLeft);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/SidebarLeft/index.js